import React from 'react';

interface AffirmToastProps {
    message: string;
    visible: boolean;
}

const AffirmToast: React.FC<AffirmToastProps> = ({ message, visible }) => (
    <div
        className="fixed bottom-6 left-1/2 z-50 w-[calc(100%-40px)] max-w-md pointer-events-none"
        style={{
            transform: visible ? 'translate(-50%, 0)' : 'translate(-50%, 20px)',
            opacity: visible ? 1 : 0,
            transition: 'transform 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.35s cubic-bezier(0.4,0,0.2,1)',
        }}
    >
        <div className="bg-navy rounded-2xl px-4 py-3 flex items-start gap-3 shadow-lg">
            <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-gold flex items-center justify-center">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path
                        d="M2.5 6L5 8.5L9.5 3.5"
                        stroke="white"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
            <p className="font-poppins text-[13px] leading-[1.4] text-white/90">{message}</p>
        </div>
    </div>
);

export default AffirmToast;
